import { faFlagCheckered } from "@fortawesome/pro-duotone-svg-icons/faFlagCheckered";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_WORKFLOWS_LINK: Breadcrumb = {
  icon: faFlagCheckered,
  name: "Workflows",
  to: "/dashboard/workflows",
};
